import { removeFieldError } from './removeFieldError.js';
export const validateAmountBlock = (form, field, errors) => {
  const wrapperSelector = '[data-drupal-selector="edit-amount-block"]'
  const parentWrapper = field.closest(wrapperSelector);
  const radioGroup = form.querySelectorAll(`input[name="amount_options"]`);
  const isChecked = Array.from(radioGroup).some(radio => radio.checked);
  const customAmount = form.querySelector(`input[name="custom_amount"]`);

  if (parentWrapper && (!isChecked && validator.isEmpty(customAmount.value))) {
    errors.push({
      field,
      wrapper: parentWrapper,
      message: 'Bitte wählen Sie einen Betrag',
    });
  }

  radioGroup.forEach(radio => {
    radio.addEventListener('change', (e) => {
      removeFieldError(field, errors, wrapperSelector);
    });
  });
  customAmount.addEventListener('input', () => {
    if (!validator.isEmpty(customAmount.value)) {
      removeFieldError(field, errors, wrapperSelector);
    } else {
      errors.push({
        field,
        wrapper: parentWrapper,
        message: 'Bitte wählen Sie einen Betrag',
      });
    }
  });
};
